import { NameAnd } from "@me8eon/record_utils";
import { BaseMessage, MessageRole, Message } from "@me8eon/messages";
import { AiStreamSink } from "@me8eon/aiclient";

export type AgentCards<Context, Pipeline, Selector> = {
    cards: NameAnd<AgentCard<Context, Pipeline>>
    selector: Selector
}

export type AgentCard<Context, Pipeline> = {
    name: string
    displayName: string
    description?: string
    disableStandaloneSelection?: boolean
    enabledForRoles: Array<string> | "all"
    disabledForRoles?: Array<[string]>
    purpose: string
    samples: string[]
    tags: string[]
    main?: boolean
    requiresAclIndices?: string[]
    pipeline: NameAnd<Pipeline>
}

export type HasType = {
    type: string
}
export type HasLastSelected = {
    lastSelected?: string
}

export type MessagesOrName = BaseMessage[] | string
export const normalizeMessagesOrName = (mn: MessagesOrName, role: MessageRole): Message[] => {
    if (typeof mn === "string") return [{ role, content: mn }];
    return mn;
};

export type PipelineDetailsData<Context> = {
    context: Context
    originalMessages: Message[]
    appendMessages?: Message[]
    suggestions?: string[]
    stream?: {
        sink?: AiStreamSink
    }
}

export const dlsAccessibleIndicesKey = "dls-accessible-indices";

export function getAccessibleIndices(): string[] {
    const raw = localStorage.getItem(dlsAccessibleIndicesKey);
    if (!raw) return [];
    return raw.split(/[,\/]/).map(s => s.trim()).filter(Boolean);
}

export function isAgentAccessible<Context, Pipeline>(agent: AgentCard<Context, Pipeline>, accessibleIndices: string[]): boolean {
    if (!agent.requiresAclIndices || agent.requiresAclIndices.length === 0) return true;
    return agent.requiresAclIndices.some(idx => accessibleIndices.includes(idx));
}
